<template>
  <transition-group
    name="staggered-fade"
    :tag=tag
    :class=className
    @before-appear="beforeAppear"
    @appear="appear"
  >
    <slot></slot>
  </transition-group>
</template>

<script>
import Velocity from 'velocity-animate'
export default {
  name: 'staggered',
  props: ['tag', 'className', 'type'],
  methods: {

    /**
     * @description Execute before render DOM
     * @param el DOM element
     */
    beforeAppear: function (el) {
      switch (this.type) {
        case 'horizontally':
          el.style.opacity = 0
          el.style.position = 'relative'
          el.style.left = '-100px'
          break
        case 'vertically':
          el.style.opacity = 0
      }
    },

    /**
     * @description Execute when render DOM
     * @param el DOM element
     * @param done Finish process
     */
    appear: function (el, done) {
      var delay = el.dataset.index * 150
      switch (this.type) {
        case 'horizontally':
          setTimeout(function () {
            Velocity(
              el,
              { opacity: 1, left: '0px' },
              { complete: done }
            )
          }, delay)
          break
        case 'vertically':
          setTimeout(function () {
            Velocity(
              el,
              { opacity: 1 },
              { complete: done }
            )
          }, delay)
          break
      }
    }
  }
}
</script>
